
import Sidebar from "./components/general/Sidebar";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Root from './pages/Root';
import EvaluationsUnifiees from "./pages/EvaluationsUnifiees";
import AddEvaluation from "./pages/AddEvaluation";
import CollerNotes from "./pages/CollerNotes";
import { ClasseProvider } from "./context/ClasseContext";
import { UserProvider } from "./context/UserContext";
import { EvalNationalProvider } from "./context/EvalNationalContext";

import PrivateRoute from "./pages/PrivateRoute";
import RestrictedRoute from "./pages/RestrictedRoute";
import CoordoRoute from "./pages/CoordoRoute";
import Login from "./pages/EspaceLogin/Login";
import GroupeBesoins from "./pages/GroupeBesoins";
import AdminGroupe from "./pages/AdminGroupe";
import RootEleve from "./pages/RootEleve";
import DataLoader from "./pages/DataLoader";
import EvalNatLoader from "./pages/EvalNatLoader";
import MyAccount from "./pages/MyAccount";
import AddCommonEval from "./components/FormEvaluation/AddCommonEval";
import CommonEval from "./pages/CommonEval";
import GroupeBesoinsNiveau from "./pages/GroupeBesoinsNiveau";
import DashBoardChef from "./pages/EspaceChef/DashboardChef";
import Ecole from "./pages/EspaceChef/Ecole";
import Evolution from "./pages/EspaceChef/Evolution";
import { useEffect } from "react";
import PeriodeScolaire from "./components/VueChefPeriode/PeriodeScolaire";
import { Navigate, useParams, useLocation, Outlet } from "react-router-dom";
import CallbackGar from "./pages/EspaceLogin/CallbackGar";
import Logout from "./pages/EspaceLogin/Logout";
import SelectEtablissement from "./pages/SelectEtablissement";
import MentionsLegales from "./mentions/MentionsLegales";
import MentionsRGPD from "./mentions/MentionsRGPD";
import CGU from "./mentions/CGU";
import ProfesseurManagement from "./components/VueChefPeriode/ProfesseurManagement";
import ImportEtablissement from "./pages/ImportEtablissement";

import ErrorBoundary from "./components/general/ErrorBoundary";
import QCMDashboard from "./pages/QCM/QCMDashboard";
import EntreeScan from "./pages/QCM/EntreeScan";
import ProjectionQCM from "./pages/QCM/ProjectionQCM";
import ResultatsExercice from "./pages/QCM/ResultatSession/ResultatsExercice";
import EvalPrintPage from "./components/Print/EvalPrintPage";
import GroupesPrintPage from "./components/Print/GroupesPrintPage";
import CreerEvaluation from "./pages/CreerEvaluation";
import PilotageCoordoTabs from "./components/general/PilotageCoordoTabs";
import PilotageNatChefTabs from "./components/general/PilotageNatChefTabs";
import GestionChefTabs from "./components/general/GestionChefTabs";

// 3.2 — l'ancienne liste evals/:id est remplacée par la liste unifiée.
// La query est préservée (?eval=<id> → ouvre directement la saisie).
const RedirectEvalsVersUnifiee = () => {
  const { idclasse } = useParams();
  const location = useLocation();
  return <Navigate to={`/home/evaluations/${idclasse}${location.search}`} replace />;
};

// Layout des pages de pilotage coordonnateur : insère la barre d'onglets coordo
// (auto-masquée hors coordonnateur) au-dessus de la page rendue par l'Outlet.
const PilotageCoordoLayout = () => (
  <>
    <PilotageCoordoTabs />
    <Outlet />
  </>
);

// Layout « Pilotage évals nationales » : eval-nat-niveau est partagé par le coordo
// délégué et le chef. On rend les DEUX barres ; chacune s'auto-masque par rôle
// (un utilisateur est soit professeur soit chef) → une seule s'affiche.
const PilotageNatLayout = () => (
  <>
    <PilotageCoordoTabs />
    <PilotageNatChefTabs />
    <Outlet />
  </>
);

// Layout « Gestion établissement » du chef (barre d'onglets auto-masquée hors chef).
const GestionChefLayout = () => (
  <>
    <GestionChefTabs />
    <Outlet />
  </>
);

const router = createBrowserRouter([
  {
    path: '/mentions',
    element: <MentionsLegales />,
    children: [
    ]
  },
   {
    path: '/cgu',
    element: <CGU />,
    children: [
    ]
  },
  {
    path: '/rgpd',
    element: <MentionsRGPD />,
    children: [
    ]
  },
  {
    path: '/login',
    element: <Login />,
    children: [
    ]
  },
  {
    // Téléphone relié par le QR projeté (chantier jeton, 2026-09-04) : page
    // PUBLIQUE, hors Sidebar et hors PrivateRoute. Le jeton est dans le
    // fragment de l'adresse ; le serveur pose un cookie de séance, et la page
    // pilote sans compte ni GAR. Cf. pages/QCM/EntreeScan.jsx.
    path: '/scan/:id',
    element: <EntreeScan />,
  },
  {
    // Route standalone pour impression PDF — pas de Sidebar, pleine page.
    // Données transmises via sessionStorage['evalPrintData'] depuis LaunchModal.
    path: '/print-eval',
    element: <EvalPrintPage />,
  },
  {
    // Groupes de besoin en papier : récapitulatif, sujets et corrigés en un
    // seul document (sessionStorage['groupesPrintData']).
    path: '/print-groupes',
    element: <GroupesPrintPage />,
  },
  {
    path: '/callback', // Après connexion du GAR
    element: <CallbackGar />,
  },
  {
    path: '/logout', // Route de déconnexion.
    element: <Logout />,
  },
   {
    path: '/',
    element: <Navigate to="/login" replace />, // Redirection automatique vers /login
  },
    {
    path: '/home/',
    element:  <Sidebar />,
    children: [
      {
        index: true,
        element: <Root />,
      },
      {
        path: 'choix-etablissement',
        element: <SelectEtablissement />,
      },
      {
        path: 'account',
        element: <MyAccount />,
      },
      {
        path: 'passation',
        element: <RootEleve />,
      },
      {
        path:'synchronisation/:idclasse',
        element:<PrivateRoute>
           <RestrictedRoute requiredAccess="full">
           <DataLoader typeComponent={"synchronisation"}/> 
           </RestrictedRoute>
                  </PrivateRoute>,
      },
      {
        path: 'detail/:idclasse', // This should be a nested route under '/classe/:idclasse'
        element: <PrivateRoute>
           <DataLoader typeComponent={"dashboard"}/> 
                  </PrivateRoute>,
      },
      {
        // Pilotage coordonnateur : ces vues établissement partagent la barre
        // d'onglets coordo via PilotageCoordoLayout (route layout sans path).
        // CoordoRoute garde les TROIS routes filles d'un coup : la barre
        // d'onglets testait déjà le rôle pour s'afficher, mais les URL
        // restaient accessibles en direct à n'importe quel professeur.
        element: <PrivateRoute><CoordoRoute><PilotageCoordoLayout /></CoordoRoute></PrivateRoute>,
        children: [
          {
            path: 'progression',
            element: <DataLoader typeComponent={"progression-commune"} />,
          },
          {
            path: 'admin-groupe/',
            element: <AdminGroupe />,
          },
          {
            path: 'groupes-common/',
            element: <GroupeBesoinsNiveau />,
          },
        ],
      },
      {
        // Pilotage évals nationales : eval-nat-niveau partagé coordo(délégué)/chef ;
        // ecoles + evolution propres au chef. PilotageNatLayout rend les deux barres.
        element: <PrivateRoute><PilotageNatLayout /></PrivateRoute>,
        children: [
          {
            path: 'eval-nat-niveau/',
            element: <DashBoardChef />,
          },
          {
            path: 'ecoles/',
            element: <Ecole />,
          },
          {
            path: 'evolution/',
            element: <Evolution />,
          },
        ],
      },
      {
        // Gestion établissement (chef) : barre d'onglets GestionChefTabs.
        element: <PrivateRoute><GestionChefLayout /></PrivateRoute>,
        children: [
          {
            path: 'professeur_gestion/',
            element: <ProfesseurManagement />,
          },
          {
            path: 'periode_scolaire/',
            element: <PeriodeScolaire />,
          },
        ],
      },
      {
        path: 'progression/:idclasse', // This should be a nested route under '/classe/:idclasse'
        element: <PrivateRoute>
            <DataLoader typeComponent={"progression-classe"} /> 
                  </PrivateRoute>,
      },
      {
        // 3.2 — redirection vers la liste unifiée (deep links préservés).
        // L'ancienne page Evaluations ne vit plus qu'en mode devoir commun
        // (via CommonEval). PrivateRoute par cohérence ; le contrôle d'accès
        // "full" est porté par la route cible evaluations/:idclasse.
        path: 'evals/:idclasse',
        element: <PrivateRoute><RedirectEvalsVersUnifiee /></PrivateRoute>,
      },
      {
        // 3.1 — liste unifiée des évaluations (3 sources).
        path: 'evaluations/:idclasse',
        element: <PrivateRoute>
        <RestrictedRoute requiredAccess="full">
        <EvaluationsUnifiees />
        </RestrictedRoute>
        </PrivateRoute>,
      },
      {
        path: 'evals/:idclasse/add', // Changed to a more appropriate path
        element: <PrivateRoute>
        <RestrictedRoute requiredAccess="full">
        <AddEvaluation />
        </RestrictedRoute>
        </PrivateRoute>,
      },
      {
        // Coller mes notes existantes (import presse-papier type Pronote) :
        // crée une évaluation en classe + ses résultats depuis un collage.
        path: 'coller-notes/:idclasse',
        element: <PrivateRoute>
        <RestrictedRoute requiredAccess="full">
        <CollerNotes />
        </RestrictedRoute>
        </PrivateRoute>,
      },
      {
        path: 'common-eval', // Changed to a more appropriate path
        element: <PrivateRoute>
        <CommonEval />
        </PrivateRoute>,
      },
      {
        path: 'add-common-eval', // Changed to a more appropriate path
        element: <PrivateRoute>
        <AddCommonEval />
        </PrivateRoute>,
      },
      {
        // Wizard d'import unique de l'établissement (délégué/chef — spec GAR §10)
        path: 'import-etablissement',
        element: <PrivateRoute>
        <ImportEtablissement />
        </PrivateRoute>,
      },
      {
        path: 'eleves/:idclasse', // Changed to a more appropriate path
        element: 
        <PrivateRoute>
       <DataLoader typeComponent={"eleves"}/>  
        </PrivateRoute>,
      },
      {
        path: 'savoirs/:idclasse', // Changed to a more appropriate path
        element:
        <PrivateRoute>
        <RestrictedRoute requiredAccess="full">
       <DataLoader typeComponent={"savoirs"} />
        </RestrictedRoute>
        </PrivateRoute>,
      },
      {
        path: 'eval-nat/:idclasse', // Changed to a more appropriate path
        element: (   <PrivateRoute>
        
        <EvalNationalProvider>
        <EvalNatLoader typeComponent={"nationale"} />
        </EvalNationalProvider>
        </PrivateRoute>
        ),
      },
      {
        path: 'eval-bilan/:idclasse', // Changed to a more appropriate path
        element: (
          <PrivateRoute>
        <RestrictedRoute requiredAccess="full">
        <EvalNatLoader typeComponent={"bilan"} />
        </RestrictedRoute>
        </PrivateRoute>
        ),
      },
      {
        path: 'groupes/:idclasse', // Changed to a more appropriate path
        element: ( 
          <PrivateRoute> 
        <GroupeBesoins />
        </PrivateRoute>
        ),
      },
      {
        // Hub de création : page d'atterrissage après le clic sur une classe/un groupe.
        path: 'creer/:idclasse',
        element: (
          <PrivateRoute>
            <CreerEvaluation />
          </PrivateRoute>
        ),
      },
      {
        path: 'qcm/:idclasse',
        element: (
          <PrivateRoute>
            <QCMDashboard />
          </PrivateRoute>
        ),
      },
      {
        path: 'qcm/:idclasse/session/:id/projection',
        element: (
          <PrivateRoute scopeSeance>
            <ProjectionQCM />
          </PrivateRoute>
        ),
      },
      {
        path: 'qcm/:idclasse/session/:id/resultats',
        element: (
          <PrivateRoute>
            <ResultatsExercice />
          </PrivateRoute>
        ),
      },

    ],
  },
]);
function App() {
  useEffect(() => {
    const disableBackForwardCache = () => {
        window.addEventListener("pageshow", function (event) {
            if (event.persisted) {  // 🚨 Détecte si la page vient du cache "Back-Forward"
              
                window.location.reload();  // 🔥 Recharge la page pour être sûr que la session est bien perdue
            }
        });
    };
  
    disableBackForwardCache();
  }, []);
  return (
   <ErrorBoundary>
     <div className="flex bg-slate-900 min-h-full">
      <UserProvider>
     <ClasseProvider>

      <RouterProvider router={router} />

      </ClasseProvider>
      </UserProvider>
    </div>
   </ErrorBoundary>
   
  );
}

export default App;
